var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{ref:"table-container",staticClass:"card mt-3 mb-3",staticStyle:{"overflow-x":"scroll"}},[_c('table',{staticClass:"display",attrs:{"id":"admin_accounts_table"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }